import { Layout, Menu } from 'antd'
import { Link } from 'react-router-dom'
import { NetlinkLogo } from '@/shared/ui/NetlinkLogo'
import { useSidebarMenu } from './useSidebarMenu'

interface AppSiderProps {
  collapsed: boolean
}

/**
 * Chap navigatsiya — DESKTOP uchun doimiy ustun.
 *
 * Menyu `GET /api/me` dagi huquqlardan QURILADI — ko'rinmaydigan sahifaga
 * havola ham chizilmaydi (04-ROLES.md §8). Mantiqning o'zi `useSidebarMenu`
 * da — mobil `Drawer` bilan BAHAM KO'RILADI, shu yerda faqat Sider qobig'i.
 *
 * ⚠️ GURUH DARAJASIDA HAM FILTRLANADI: ichidagi hamma element yopiq bo'lsa,
 * guruhning O'ZI ham chizilmaydi. Aks holda foydalanuvchi "Moliya" ni bosadi
 * va bo'sh ro'yxat ochiladi — bu havola yo'qligidan ham yomonroq, chunki
 * u xatoga o'xshaydi.
 *
 * AKKORDEON: bir vaqtda faqat BITTA guruh ochiq. Sabab amaliy — bo'limlar
 * yana ko'payadi va hammasi ochiq bo'lsa sidebar scroll qilinadigan uzun
 * ro'yxatga aylanadi, ya'ni yopiladigan qilishning ma'nosi qolmaydi.
 *
 * ⚠️ TOR EKRANDA YASHIRILADI (`global.css` emas, `AppLayout` shartli
 * chizadi) — o'rniga `MobileNavDrawer` ishlatiladi, chunki doimiy ustun
 * telefon ekranining yarmini yeb qo'yardi.
 */
export function AppSider({ collapsed }: AppSiderProps) {
  const menu = useSidebarMenu(collapsed)

  return (
    <Layout.Sider
      className="xsib-sider"
      theme="dark"
      collapsed={collapsed}
      collapsedWidth={64}
      width={240}
      trigger={null}
    >
      <Link
        to="/"
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: collapsed ? 'center' : 'flex-start',
          paddingInline: collapsed ? 0 : 18,
          overflow: 'hidden',
        }}
      >
        {collapsed ? (
          <NetlinkLogo variant="mark" height={28} onDark />
        ) : (
          <NetlinkLogo variant="compact" height={28} onDark />
        )}
      </Link>

      <Menu
        theme="dark"
        mode="inline"
        items={menu.items}
        selectedKeys={[menu.selectedKey]}
        // Yig'ilgan sidebar'da guruhlar suzuvchi oynada ochiladi va antd
        // ularni O'ZI boshqaradi. `openKeys` ni baribir berish ogohlantirish
        // chiqaradi va suzuvchi oyna ochilmay qoladi (`useSidebarMenu`
        // `collapsed` bo'lganda ikkalasini ham `undefined` qilib beradi).
        {...(menu.openKeys === undefined ? {} : { openKeys: menu.openKeys, onOpenChange: menu.onOpenChange })}
        onClick={menu.onClick}
      />
    </Layout.Sider>
  )
}
